import React from 'react';

const DeleteAccount = () => {
  return (
    <div className="max-w-2xl mx-auto px-4 py-10 font-sans text-gray-700">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Delete Your Account</h1>

      <p className="mb-4">
        If you would like to delete your account, please email us at{' '}
        <a
          href="mailto:gfeltp@gmail.com"
          className="text-blue-600 underline hover:text-blue-800"
        >
          gfeltp@gmail.com
        </a>{' '}
        using the email address associated with your account.
      </p>

      <p className="mb-4">
        Once we receive your request, we will verify your identity and delete your account
        within 5 business days.
      </p>

      <div className="mt-6 p-4 bg-red-100 border-l-4 border-red-500 text-red-700">
        <strong>Note:</strong> Account deletion is permanent and cannot be undone.
      </div>
    </div>
  );
};

export default DeleteAccount;
